var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "addFilter",
    d: "M18.0251 12.2917C18.0251 13.0334 17.8167 13.7334 17.4501 14.3334C16.7667 15.4834 15.5084 16.25 14.0667 16.25C12.6251 16.25 11.3667 15.4751 10.6834 14.3334C10.3167 13.7417 10.1084 13.0334 10.1084 12.2917C10.1084 10.1084 11.8834 8.33337 14.0667 8.33337C16.2501 8.33337 18.0251 10.1084 18.0251 12.2917Z",
    stroke: "#171D27",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "addFilter",
    d: "M15.5501 12.275H12.5918",
    stroke: "#171D27",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "addFilter",
    d: "M14.0669 10.8334V13.7917",
    stroke: "#171D27",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "addFilter",
    d: "M17.2416 3.34998V5.19995C17.2416 5.87495 16.8166 6.71663 16.4 7.14163L14.9333 8.43329C14.6583 8.36662 14.3666 8.33329 14.0666 8.33329C11.8833 8.33329 10.1083 10.1083 10.1083 12.2916C10.1083 13.0333 10.3166 13.7333 10.6833 14.3333C10.9916 14.85 11.4166 15.2916 11.9333 15.6083V15.8916C11.9333 16.4 11.6 17.0749 11.175 17.3249L9.99997 18.0833C8.9083 18.7583 7.39163 17.9999 7.39163 16.6499V12.1916C7.39163 11.6 7.04997 10.8416 6.71663 10.425L3.51663 7.05827C3.09997 6.63327 2.7583 5.87497 2.7583 5.37497V3.43329C2.7583 2.42496 3.51663 1.66663 4.44163 1.66663H15.5583C16.4833 1.66663 17.2416 2.42498 17.2416 3.34998Z",
    stroke: "#171D27",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAdd);
export default __webpack_public_path__ + "static/media/filter-add.beaa21f522cd8379ce79d7ec530dbc4d.svg";
export { ForwardRef as ReactComponent };